module.exports = __webpack_public_path__ + "static/headshot--terrace-d1f9ab85a8e921576c99269883cddebc.jpg";